import { ReferrerActionTypes } from './referrer.types';

export const initialState = {
  extoleJwt: {
    value: null,
    loading: false,
    error: false,
  },
};

const referrerReducer = (state = initialState, action) => {
  switch (action.type) {
    case ReferrerActionTypes.SET_EXTOLE_JWT_LOADING:
      return {
        ...state,
        extoleJwt: {
          ...state.extoleJwt,
          loading: action.payload.loading,
          error: false,
        },
      };
    case ReferrerActionTypes.GET_EXTOLE_JWT_SUCCESS:
      return {
        ...state,
        extoleJwt: {
          value: action.payload.data,
          loading: false,
          error: false,
        },
      };
    case ReferrerActionTypes.GET_EXTOLE_JWT_FAILURE:
      return {
        ...state,
        extoleJwt: {
          ...state.extoleJwt,
          loading: false,
          error: true,
        },
      };
    default:
      return state;
  }
};

export default referrerReducer;
